<template>
  <div class="bg">
    <!-- <img style="width: 100%;" src="@assets/img/at.png" alt="" srcset=""> -->
    <div class="innerBox">
      <div class="title">一、答题日期</div>
      <div class="time">{{ time }}</div>
      <div class="title">二、答题规则</div>
      <div class="time">
        （1）每人{{ count }}题，每题{{
          point
        }}分，答题类型为选择题，试题从题库中随机抽取。 <br />
        （2）答题不限制答题时间，答题次数限制为每人三次。 你已回答{{
          num
        }}次。<br />
        （3）题目答案确定后不可更改，跳转下一题后无法返回上一题，答错也可继续答题，答题结束按分数奖励积分。<br />
      </div>
      <div class="mark" v-if="num == 3">您的答题次数已用完</div>
      <van-button
        style="margin-top: 0.9rem"
        type="danger"
        block
        round
        @click="todati"
        v-if="num < 3"
        >开始答题</van-button
      >
      <!-- <img class="foot" src="@/assets/img/footer.png" alt="" srcset="" /> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Button } from "vant";
import { getPartAnswerInfo } from "@api/answer";

Vue.use(Button);

export default {
  data() {
    return {
      time: "",
      status: 0,
      msg: "",
      count: "",
      point: 0,
      num: 0,
    };
  },
  created() {
    this.getdate();
  },
  methods: {
    getdate() {
      getPartAnswerInfo()
        .then((res) => {
          this.time = res.data.time;
          this.count = res.data.count;
          this.point = res.data.point;
          this.status = res.data.status;
          if (res.data.num) {
            this.num = res.data.num;
          }
        })
        .catch((err) => {
          this.time = err.data.data.time;
        });
    },
    todati() {
      this.$router.push({ path: "/answer/partydati" });
      /* getPartAnswer()
        .then((res) => {
          
        })
        .catch((err) => {
          this.$dialog.error(err.msg);
        }); */
    },
  },
};
</script>

<style scoped>
.mark {
  padding-top: 0.5rem;
  text-align: center;
  font-size: 0.3rem;
  color: #fc0000;
}
.bg {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: url("~@assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.innerBox {
  margin: 3%;
  background: #fdf9ee;
  border-radius: 0.2rem;
  position: absolute;
  bottom: 0;
  width: 94%;
  top: 0.2rem;
  right: 0;
  left: 0;
  padding: 0.34rem;
  color: #202020;
}
.title {
  font-size: 0.3rem;
  line-height: 0.5rem;
}
.time {
  font-size: 0.3rem;
  line-height: 0.5rem;
  padding: 0.1rem 0;
}
.foot {
  display: block;
  width: 80%;
  position: absolute;
  left: 10%;
  bottom: 0.3rem;
}
</style>
